/** Spec §3.2 locked decision #14. Permanent for v1; rotate via "-v2" suffix. */
export const PRF_INPUT_LABEL = 'cere-wallet-prf-v1';

/**
 * SHA-256("cere-wallet-prf-v1") — 32 bytes. Fed to WebAuthn `prf.eval.first`.
 *
 * Hard-coded as a byte literal so this module is browser-safe with NO
 * `node:crypto` dependency — it is evaluated at module-load time, and relying on
 * `createHash` there forced every browser consumer to wire a `node:crypto`
 * polyfill (`vite-plugin-node-polyfills`). The literal is verified to equal
 * `sha256(PRF_INPUT_LABEL)` in `constants.test.ts`, so the constant cannot drift
 * silently. Rotating the label (`-v2`) means recomputing these bytes.
 */
export const PRF_INPUT_SEED: Uint8Array = new Uint8Array([
  241, 55, 252, 128, 200, 121, 231, 173, 149, 167, 104, 105, 124, 215, 6, 125, 113, 218, 113, 114, 238, 51, 232, 185,
  156, 209, 26, 46, 78, 6, 58, 137,
]);

/** Spec §3.2. Used as HKDF-SHA256 info to derive the secp256k1 32-byte secret. */
export const EVM_HKDF_INFO = 'cere-wallet-evm-secp256k1-v1';
